
import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = React.useState(false);
  const [dropdownTimeout, setDropdownTimeout] = React.useState<NodeJS.Timeout | null>(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleMouseEnterServices = () => {
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      setDropdownTimeout(null);
    }
    setIsServicesDropdownOpen(true);
  };

  const handleMouseLeaveServices = () => {
    const timeout = setTimeout(() => {
      setIsServicesDropdownOpen(false);
    }, 150); // 150ms delay
    setDropdownTimeout(timeout);
  };
  
  return (
    <nav className="w-full bg-white shadow-sm py-4 px-6 sticky top-0 z-50">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="/noord-ai.png" 
              alt="Noord AI Logo" 
              className="h-10 w-auto mr-3"
            />
            <div className="flex flex-col">
              <span className="text-noordblue font-bold text-xl">Noord AI</span>
              <span className="text-gray-600 text-xs">Samen een stap naar morgen</span>
            </div>
          </Link>
          
          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-noordblue font-medium">Home</Link>
            
            {/* Services Dropdown */}
            <div 
              className="relative"
              onMouseEnter={handleMouseEnterServices}
              onMouseLeave={handleMouseLeaveServices}
            >
              <button className="flex items-center gap-1 text-gray-700 hover:text-noordblue font-medium">
                Diensten
                <ChevronDown className={`h-4 w-4 transition-transform ${isServicesDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isServicesDropdownOpen && (
                <div className="absolute top-full left-0 -mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50">
                  <Link 
                    to="/diensten" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-noordblue"
                  >
                    Alle Diensten
                  </Link>
                  <div className="border-t border-gray-100 my-1"></div>
                  <a 
                    href="https://bobbette.noord-ai.nl" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-noordblue"
                  >
                    <div className="font-medium">Bobbette</div>
                    <div className="text-sm text-gray-500">Slimme OpenAI agent voor offertes</div>
                  </a>
                </div>
              )}
            </div>
            
            <Link to="/prijzen" className="text-gray-700 hover:text-noordblue font-medium">Prijzen</Link>
            <Link to="/blog" className="text-gray-700 hover:text-noordblue font-medium">Blog</Link>
            <Link to="/contact" className="text-gray-700 hover:text-noordblue font-medium">Contact</Link>
          </div>
          
          <div className="hidden md:block">
            <Button className="bg-noordblue hover:bg-noordblue-dark text-white" asChild>
              <Link to="/contact">
                Plan een gesprek
              </Link>
            </Button>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button 
              className="outline-none focus:outline-none" 
              onClick={toggleMenu}
            >
              {isMenuOpen ? <X className="h-6 w-6 text-gray-700" /> : <Menu className="h-6 w-6 text-gray-700" />}
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white shadow-md py-4 z-50">
            <div className="flex flex-col space-y-4 px-6">
              <Link 
                to="/" 
                className="text-gray-700 hover:text-noordblue font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/diensten" 
                className="text-gray-700 hover:text-noordblue font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Diensten
              </Link>
              <Link 
                to="/prijzen" 
                className="text-gray-700 hover:text-noordblue font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Prijzen
              </Link>
              <Link 
                to="/blog" 
                className="text-gray-700 hover:text-noordblue font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link 
                to="/contact" 
                className="text-gray-700 hover:text-noordblue font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <Button 
                className="bg-noordblue hover:bg-noordblue-dark text-white w-full"
                onClick={() => setIsMenuOpen(false)}
                asChild
              >
                <Link to="/contact">
                  Plan een gesprek
                </Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
